import React from 'react'

import Wrapper from '../../components/Wrapper'

import Slide from './Slide';

export default (props) => (
  <Wrapper>
    <Slide {...props} />
  </Wrapper>
)